//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    clickHandler: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    handleClick(e) {
      this.copied = true
      this.clickHandler(e)
      setTimeout(() => {
        this.copied = false
      }, 5000)
    },
  },
}
